import React, { useEffect, useState } from 'react'
import Trips from './components/Trips';
import TruckOrders from './components/TruckOrders';
import Awbs from './components/Awbs';
import SettingsNew from '../Settings/SettingsNew';
import LeftMenu from '../../Components/Layout/LeftMenu';
import Header from '../../Components/Layout/Header';

import { ReactComponent as CRIcon } from "../../assets/images/sidebar/driver.svg";
import { ReactComponent as AtIcon } from "../../assets/images/sidebar/alltrips.svg";
import { ReactComponent as ImportIcon } from "../../assets/images/sidebar/import.svg";
import { ReactComponent as AwbIcon } from "../../assets/images/sidebar/awb_view.svg";
import { ReactComponent as SettingsIcon } from "../../assets/images/sidebar/settings.svg";
import { ReactComponent as US } from "../../assets/images/settings_icon/resourcesettings.svg";
import TripEditModal from './components/common/TripEditModal';
import TODetails from './components/TODetails';
import AwbDetails from './components/AwbDetails';
import IncomingFlights from './components/IncomingFlights';
import { useUserCheckQuery } from '../../redux/services/Auth';

const Trucker = () => {

    const initialTab = localStorage.getItem("MainTab");
    const initPage = localStorage.getItem("InnerPage") || '';
    const [innerPage, setInnerPage] = useState(initPage || '');

    const tabs = ['TR', 'TO', 'AW', 'IF', 'ST',].includes(initialTab);
    const [mainTab, setMainTab] = useState(tabs ? initialTab : 'TR');
    const initTitle = { title: 'Trucker' }
    const [sendHeader, setSendHeader] = useState(initTitle);
    const [isIconClosed, setIsIconClosed] = useState(true);
    const [gridRefetch, setGridRefetch] = useState(false);
    const [userDetails, setUserDetails] = useState();

    const sections = ['main', 'report', 'settings'];
    const navItems = {
        home: false,
        button: { name: 'Create Trip', icon: 'addIcon', cls: 'add_cover', },
        main: [
            { path: 'TR', name: 'Trips', heading: 'Trips', icon: <CRIcon className='menu-icon' /> },
            { path: 'TO', name: 'Truck Orders', heading: 'Truck Orders', icon: <AtIcon className='menu-icon' /> },
            { path: 'AW', name: 'AWBs', heading: 'AWBs', icon: <AwbIcon className='menu-icon' /> },
            { path: 'IF', name: 'Incoming Flights', heading: 'Incoming Flights', icon: <ImportIcon className='menu-icon' /> },

        ],
        settings: [
            { path: 'ST', name: 'Settings', heading: 'Settings', icon: <SettingsIcon className='menu-icon' /> },
        ]
    };

    const settingsNav = [
        // {
        //     name: 'Slotplanning',
        //     items: [
        //         { name: 'Door Configuration', path: '#', icon: <DC />, tab: 'spl_drc', default: true },
        //         { name: 'Slot Settings', path: '#', icon: <SC />, tab: 'spl_slt', },
        //         // { name: 'Trucker Settings', path: '#', image: Uprofile, tab: 'trs', },
        //         // { name: 'Airline Settings', path: '#', image: Uprofile, tab: 'ars', },
        //         { name: 'Resource Settings', path: '#', icon: <RS />, tab: 'spl_rss', },
        //     ]
        // },
        {
            name: 'Trucker Settings',
            settingsSearch: false,
            items: [
                { name: 'User Settings', path: '#', icon: <US />, tab: 'trk_usr', default: true },
                // { name: 'Groups', path: '#', icon: <RS />, tab: 'spl_grp', },
            ]
        }
    ];

    const handleCollapse = (value) => {
        setIsIconClosed(value);
    };

    useEffect(() => {

        const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === mainTab)

        // if (findRow?.sub && initialSub) {
        //     const subRow = findRow.sub.find(i => i.path === initialSub)
        //     // setSubHead(subRow?.heading || subRow?.name)
        //     setSendHeader({
        //         ...initTitle,
        //         subTitle: subRow?.heading || subRow?.name
        //     });
        // } else {
        setSendHeader({
            ...initTitle,
            subTitle: findRow?.heading || findRow?.name
        });
        // }
    }, []);

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    const handleNavClick = (main = null, page = '') => {
        // if (['IM', 'EX', 'UL', 'ML'].includes(main)) {
        //   toast.warning('Page is under construction!');

        // } else {
        if (page) {
            setInnerPage(page);
            localStorage.setItem('InnerPage', page);
        }
        if (main) {
            setInnerPage('');
            localStorage.setItem('InnerPage', '');

            setMainTab(main.path);
            const findRow = sections.flatMap(sections => navItems?.[sections] || []).find(i => i.path === main.path)
            setSendHeader({
                ...initTitle,
                subTitle: findRow?.heading || findRow?.name
            });

            localStorage.setItem('MainTab', main.path);
        }
    }

    const [mode, setMode] = useState(null);
    const addTrip = (pos) => {
        if (pos) {
            setMode(pos)
        } else {
            setMode('create')
        }
    }
    const closeModal = () => {
        setMode(null);
        setGridRefetch(true);
    }

    return (
        <>
            <div className="d-flex">
                <LeftMenu userInfo={userDetails} isIconClosed={isIconClosed} selTab={mainTab} navs={navItems} onNav={handleNavClick} onAdd={addTrip} />
                <div className="mainbody-right">
                    <Header userInfo={userDetails} isIconClosed={isIconClosed} oncollapsed={handleCollapse} propData={sendHeader} />

                    <div className="">
                        {innerPage === '' &&
                            <>
                                {mainTab === 'TR' && <Trips gridRefetch={gridRefetch} />} {/*  reloadGrid={onReload} */}
                                {mainTab === 'TO' && <TruckOrders detailsClick={() => handleNavClick('', 'TOD')} />}
                                {mainTab === 'AW' && <Awbs detailsClick={() => handleNavClick('', 'AWD')} />}
                                {mainTab === 'IF' && <IncomingFlights />}
                                {mainTab === 'ST' && <SettingsNew onSnav={settingsNav} />}
                            </>
                        }
                        {innerPage === 'TOD' && <TODetails onBack={() => handleNavClick({ path: 'TO' }, '')} />}
                        {innerPage === 'AWD' && <AwbDetails onBack={() => handleNavClick({ path: 'AW' }, '')} />}
                    </div>
                </div>
            </div >
            <TripEditModal
                // rowData={rowData}
                // setRowData={setRowData}
                // onSuccess={refreshGrid}
                onClose={closeModal}
                mode={mode}
            // setMode={setMode}
            />
        </>
    )
}

export default Trucker;